import { render, staticRenderFns } from "./XIcon.vue?vue&type=template&id=597f7d0a&"
import script from "./XIcon.vue?vue&type=script&lang=js&"
export * from "./XIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports